module.exports = __webpack_public_path__ + "img/elhomes.5aeb87fd.svg";